// English locale strings are default - don't need to import them
import 'moment/locale/de';
import 'moment/locale/el';
import 'moment/locale/es';
